export const processProblemOption = [
    {
        label: "外观",
        value: "外观"
    },
    {
        label: "功能",
        value: "功能"
    },
    {
        label: "参数",
        value: "参数"
    },
];
